import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  inheritAttrs: false
})
export default class CardComponent extends Vue {
  @Prop({ type: String, default: "secondary" }) color!: string;
  @Prop({ type: [Number, String], default: 10 }) elevation!: string;
  @Prop({ type: Boolean, default: false }) inline!: string;
  @Prop({ type: Boolean, default: false }) fullWidth!: string;
  @Prop({ type: String, default: undefined }) title!: string;
  @Prop({ type: String, default: undefined }) text!: string;
}